"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
class Interval {
    constructor({ from, to, label }) {
        this.toJSON = () => ({
            from: this.from,
            to: this.to,
            label: this.label,
        });
        this.from = from;
        this.to = to;
        this.label = label;
    }
}
Interval.fromJSON = (json) => {
    const { from, to, label } = Object.assign({}, json);
    if (typeof from !== 'string')
        throw new Error('.from must be a string');
    if (typeof to !== 'string')
        throw new Error('.to must be a string');
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    return new Interval({
        from: luxon_1.DateTime.fromISO(from),
        to: luxon_1.DateTime.fromISO(to),
        label: label,
    });
};
exports.default = Interval;
